// modules/website/components/TeamComponent.tsx

import React from 'react';
import { TeamData } from '@/types';
import { Instagram, MessageCircle } from 'lucide-react';

interface Props {
  data: TeamData;
  settings: any;
}

export const TeamComponent: React.FC<Props> = ({ data, settings }) => {
  return (
    <div 
      className="py-20 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
      }}
    >
      <div className="max-w-7xl mx-auto">
        {data.title && (
          <h2 className="text-4xl font-bold text-center mb-12">
            {data.title}
          </h2>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {data.members
            .sort((a: any, b: any) => a.order - b.order)
            .map((member: any) => (
              <div
                key={member.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group"
              >
                {/* Photo */}
                <div className="relative overflow-hidden aspect-square">
                  <img 
                    src={member.image || '/placeholder-team.jpg'} 
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  {/* Social Links Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
                    {member.instagram && (
                      <a
                        href={member.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white text-gray-900 p-3 rounded-full hover:bg-gray-100 transition-colors"
                      >
                        <Instagram size={24} />
                      </a>
                    )}
                    {member.whatsapp && (
                      <a
                        href={`https://wa.me/${member.whatsapp.replace(/\D/g, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white text-gray-900 p-3 rounded-full hover:bg-gray-100 transition-colors"
                      >
                        <MessageCircle size={24} />
                      </a>
                    )}
                  </div>
                </div>

                {/* Info */}
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1">{member.name}</h3>
                  <p className="text-blue-600 font-medium mb-3">{member.role}</p>
                  <p className="text-gray-600 text-sm leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
